// generated from 258_524 samples

import { z } from "zod";

export const usedAppTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::UsedApp"),
  // null: 221_563 (85.70%)
  app_ids: z
    .array(
      // format object-id: 36_045 (97.53%)
      z.string()
    )
    .nullable(),
  type: z.literal("open"),
});
